export default [
  {
    icon: 'mdi-file-document-outline',
    name: 'Facturación',
    path: '/openbilling',
    component: () => import(/* webpackChunkName: "openbilling" */ '@/views/RouterViewComponent'),
    beforeEnter: (to, from, next) => {
      window.location.href = '/v2/facturacion/ventas';
    },
    redirect: '/openbilling/ventas/facturas',
    id: 'openbilling-toolbar',

    meta: {
      allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      module: 'billing',
      requiresAuth: true,
      toolbar: true,
      tooltip: null,
    },
    children: [
      // {
      //   name: 'Dashboard',
      //   icon: 'mdi-calculator',
      //   path: '/openbilling/dashboard',
      //   component: () =>
      //     import(/* webpackChunkName: "openbilling-dashboard" */ './views/OpenBillingDashboard'),
      //   meta: {
      //     allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
      //     requiresAuth: true,
      //     drawer: true,
      //     tooltip: null,
      //   },
      // },
      {
        name: 'Facturas',
        icon: 'mdi-calculator',
        path: '/openbilling/ventas/facturas',
        component: () =>
          import(/* webpackChunkName: "openbilling-invoice" */ './views/OpenBillingSalesInvoiceList'),
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion/ventas';
        },
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Ventas recurrentes',
        icon: 'mdi-finance',
        path: '/openbilling/ventas/facturas-recurrentes',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion';
        },
        component: () =>
          import(/* webpackChunkName: "openbilling-invoice" */ './views/OpenBillingRecursiveSalesInvoiceList'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Presupuestos',
        icon: 'mdi-file-outline',
        path: '/openbilling/ventas/presupuestos',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion';
        },
        component: () =>
          import(/* webpackChunkName: "openbilling-invoice" */ './views/OpenBillingSalesBudgetList'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Contactos',
        icon: 'mdi-account-box',
        path: '/openbilling/contactos',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion';
        },
        component: () =>
          import(/* webpackChunkName: "openbilling-contacts" */ './views/OpenBillingContacts'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Productos',
        icon: 'mdi-ticket',
        path: '/openbilling/productos',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion';
        },
        component: () =>
          import(/* webpackChunkName: "openbilling-products" */ './views/OpenBillingProducts'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
      {
        name: 'Configuración',
        icon: 'mdi-tune',
        path: '/openbilling/configuracion',
        beforeEnter: (to, from, next) => {
          window.location.href = '/v2/facturacion';
        },
        component: () =>
          import(/* webpackChunkName: "openbilling-settings" */ './views/OpenBillingSettings'),
        meta: {
          allowedRoles: ['pyme', 'autonomous', 'employees', 'consultant', 'admin', 'superadmin'],
          module: 'billing',
          requiresAuth: true,
          drawer: true,
          tooltip: null,
        },
      },
    ],
  },
];
